import { mapState, mapActions } from 'vuex';

const billingRoutes = [
  'NewShoppingCart',
  'CreateReelOrder',
  'NewShoppingCartPR',
  'CreateKitOrder',
  'CreateRequestForQuotation',
  'CreateReelReminderOrder',
  'backordersHistory',
];

export default {
  methods: {
    ...mapActions('moduleMaintenanceStatus', [
      'checkBillingModuleActive',
      'setIsBillingModuleActive',
    ]),
    ...mapActions('modalStepsAfterLogin', [
      'updateModalState',
      'findStepByKey',
      'changeCurrentStepValue',
      'updateStepStatus',
      'loadBillingModuleStatusStep',
    ]),

    normalizeBillingState(value) {
      return String(value) === '0';
    },
    async launchBillingStepModal() {
      await this.loadBillingModuleStatusStep();
      const billingStep = await this.findStepByKey('billingModuleStatus');

      if (billingStep) {
        billingStep.visited = true;
        this.updateStepStatus(billingStep);
        this.changeCurrentStepValue(billingStep.value);
        this.updateModalState(true);
      }
    },
    checkInitialRouteAccess() {
      if (this.isBillingRouteDisabled(this.currentRouteName)) {
        this.launchBillingStepModal();
        this.$router.push({ name: 'Home' });
      }
    },
    isBillingRouteDisabled(routeName) {
      return (
        this.isBillingModuleActive &&
        routeName &&
        billingRoutes.includes(routeName)
      );
    },
    async checkBillingBeforeGenerateOrder() {
      if (this.isBillingModuleActive) {
        await this.launchBillingStepModal();
        return false;
      }
      return true;
    },
    async redirectIfBillingModuleDisabled(billingState) {
      const isDisabled = this.normalizeBillingState(billingState);

      if (!isDisabled) return false;

      await this.setIsBillingModuleActive(true);
      await this.launchBillingStepModal();
      this.$router.push({ name: 'Home' });

      return true;
    },
  },

  computed: {
    ...mapState('moduleMaintenanceStatus', ['isBillingModuleActive']),
    currentRouteName() {
      return this.$route.name;
    },
  },
};
